import { useQueryClient } from '@tanstack/react-query';
import { MAIN_PUBLISHED_QUERY_KEY, usePublishedKey } from './usePublishedQuery';
import { PublishedModel, PublishedPageData } from '../interfaces/api';
import { ASSET_EMBEDS_KEY } from '@/app/assets/details/organisms/hooks';

export const usePublishedOptimisticUi = () => {
  const queryClient = useQueryClient();
  const key = usePublishedKey();

  const deletePublishedModel = (id: number, assetId: number) => {
    queryClient.setQueryData<PublishedPageData>(key, (prev) => {
      if (!prev) {
        return prev;
      }

      const filteredData = prev.data.filter((model) => model.id !== id);

      return {
        ...prev,
        data: filteredData,
      };
    });

    queryClient.setQueryData<PublishedModel[]>([ASSET_EMBEDS_KEY, assetId], (prev) => {
      if (!prev) {
        return prev;
      }

      return prev.filter((model) => model.id !== id);
    });
  };

  const invalidateQueries = (assetId: number) => {
    queryClient.invalidateQueries({ queryKey: [MAIN_PUBLISHED_QUERY_KEY] });
    queryClient.invalidateQueries({ queryKey: [ASSET_EMBEDS_KEY, assetId] });
  };

  return { deletePublishedModel, invalidateQueries };
};
